export const COFFEE_GET_SETTINGS_REQUESTING = "COFFEE_GET_SETTINGS_REQUESTING";
export const COFFEE_GET_SETTINGS_SUCCESS = "COFFEE_GET_SETTINGS_SUCCESS";
export const COFFEE_GET_SETTINGS_ERROR = "COFFEE_GET_SETTINGS_ERROR";
export const COFFEE_MODIFY_SETTINGS_REQUESTING =
  "COFFEE_MODIFY_SETTINGS_REQUESTING";
export const COFFEE_MODIFY_SETTINGS_SUCCESS = "COFFEE_MODIFY_SETTINGS_SUCCESS";
export const COFFEE_MODIFY_SETTINGS_ERROR = "COFFEE_MODIFY_SETTINGS_ERROR";
export const COFFEE_CHANGE_SETTINGS = "COFFEE_CHANGE_SETTINGS";
export const COFFEE_CLOSE_SNACK_MESSAGE = "COFFEE_CLOSE_SNACK_MESSAGE";
